module.exports = __webpack_public_path__ + "images/0adcadc0fc766e0eee6b86851363915b113f61df74b527281a500be959cc508d.svg";